import * as React from "react";
import ScheduleSidebar from "./ScheduleSidebar";
class ScheduleHome extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  componentDidMount() {
  }
  componentWillUnmount() {
  }
  componentDidUpdate() {
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: "sidebarLayout d-flex flex-row flex-fill" }, /* @__PURE__ */ React.createElement("div", { className: "sidebar-container" }, /* @__PURE__ */ React.createElement(ScheduleSidebar, null)), /* @__PURE__ */ React.createElement("div", { className: "flex-fill" }, /* @__PURE__ */ React.createElement("div", { className: "h-100 d-flex flex-column align-items-center justify-content-center" }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-calendar-check", size: "6x" }), /* @__PURE__ */ React.createElement(
      "h2",
      {
        style: {
          fontWeight: "bolder",
          fontStyle: "italic",
          margin: "16px"
        }
      },
      "Schedules"
    ))));
  }
}
export default ScheduleHome;
